import { defineAsyncComponent } from 'vue';
import HawkLoader from '~/common/components/atoms/hawk-loader.vue';

const routes = [
  {
    path: '/jobs',
    name: 'jobs',
    component: defineAsyncComponent({
      loader: () => import('~/jobs/pages/jobs.vue'),
      loadingComponent: HawkLoader,
    }),
  },

];
export default routes;
